const CONTENT_TYPE = 'application/json';
const JSON_REPLACER = null;
const JSON_SPACE = 2;

export function stringifyFileData(data) {
  return JSON.stringify(data, JSON_REPLACER, JSON_SPACE);
}

export function getConfigFile(name, data) {
  return {
    data: stringifyFileData(data),
    type: CONTENT_TYPE,
    filename: `${name}.json`,
  };
}
